import forEach from 'lodash/forEach'
import find from 'lodash/find'

export default {
  setPersonalTypeList: (state, list) => (state.personalTypes = list),
  setUserInfoList: (state, list) => (state.userInfo = list),
  setAccountInfoList: (state, list) => (state.accountInfo = list),
  setDeliveryTypeList: (state, list) => (state.delivery.types = list),
  setDeliveryCountryList: (state, list) => (state.delivery.country = list),
  setDeliveryFieldList: (state, list) => (state.delivery.fields = list),
  setDeliveryServiceFieldList: (state, list) => (state.delivery.serviceFields = list),
  setDeliveryItems: (state, list) => (state.delivery.items = list),
  setDeliveryPickupItems: (state, list) => (state.delivery.pickupItems = list),
  setPaymentsList: (state, list) => (state.payments.items = list),
  setPrice: (state, price) => (state.price = price),
  setBasketData: (state, data) => (state.basket = data),
  setUserInfoValidate: (state, val) => (state.isValidateUserInfo = val),
  setAccountInfoValidate: (state, val) => (state.isValidateAccountInfo = val),
  setValidateDelivery: (state, val) => (state.isValidateDelivery = val),
  addGlobalErrors: (state, val) => (state.globalErrors.push(val)),
  setMovingStatus: (state, val) => (state.movingStatus = val),
  clearGlobalErrors: state => (state.globalErrors = []),
  setProfileList: (state, list) => (state.profileList = list),
  setPaymentData: (state, data) => (state.payments = data),
  setProfileNew: state => {
    forEach(state.profileList, e => {
      e.selected = e.id === 0
    })
  },
  setPersonalTypeById: (state, id) => {
    state.personalTypes = forEach(state.personalTypes, e => {
      e['selected'] = id === e.id
    })
  },
  setUserInfoValueById: (state, {id, value}) => {
    let item = find(state.userInfo, {id: id})
    item.value = value
  },
  setUserInfoValueByCode: (state, {code, value}) => {
    let item = find(state.userInfo, {code: code})
    item.value = value
  },
  setAccountInfoValueById: (state, {id, value}) => {
    let item = find(state.accountInfo, {id: id})
    item.value = value
  },
  setAccountInfoValueByCode: (state, {code, value}) => {
    let item = find(state.accountInfo, {code: code})
    item.value = value
  },
  setPaymentById: (state, id) => {
    state.payments.items = forEach(state.payments.items, e => {
      e['selected'] = id === e.id
    })
  },
  setIsSubscribe: (state, value) => (state.isSubscribe = value),
  setBasketItemCountById: (state, payload) => {
    let item = find(state.basket.items, {id: payload.id})
    item.count = payload.value
  },
  setDeliveryCountryById: (state, id) => {
    state.delivery.country = forEach(state.delivery.country, e => {
      e['selected'] = id === e.id
    })
  },
  setDeliveryTypeById: (state, id) => {
    state.delivery.types = forEach(state.delivery.types, e => {
      e['selected'] = id === e.id
    })
  },
  setDeliveryFiledValueById: (state, {id, value}) => {
    let item = find(state.delivery.fields, {id: id})
    item.value = value
  },
  setDeliveryFiledValueByCode: (state, {code, value}) => {
    let item = find(state.delivery.fields, {code: code})
    item.value = value
  },
  setDeliveryFiledDataByCode: (state, {code, data}) => {
    let item = find(state.delivery.fields, {code: code})
    item.data = data
  },
  setDeliveryFiledValidById: (state, {id, value}) => {
    let item = find(state.delivery.fields, {id: id})
    item.isValid = value
  },
  setDeliveryServiceFiledValueByCode: (state, {code, value}) => {
    let item = find(state.delivery.serviceFields, {code: code})
    item.value = value
  },
  setDeliveryPickupItemById: (state, id) => {
    state.delivery.pickupItems = forEach(state.delivery.pickupItems, e => {
      e['selected'] = id === e.id
    })
  },
  setShowLoadData: (state, value) => {
    state.isShowLoadData = value
  },
  setIsAuthorized: (state, value) => {
    state.isAuthorized = value
  },
  setMoving: (state, data) => {
    state.moving = data
  },
  setMovingAvailabilityByItem (state, { basketItemId, availability }) {
    const assignObj = {}
    assignObj[basketItemId] = availability

    state.movingAvailabilityByItem = {...state.movingAvailabilityByItem, ...assignObj}
  }

}



// WEBPACK FOOTER //
// ./src/components/store/modules/order/mutations.js